/**
 * @generated SignedSource<<1c1fba11f3d72542f118297ded1e50b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type labelCategoryRow_labelCategory$data = {
  readonly id: string;
  readonly name: string | null;
  readonly allowOnTasks: boolean | null;
  readonly allowOnProjects: boolean | null;
  readonly allowOnPeople: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"labelRow_labelCategory">;
  readonly " $fragmentType": "labelCategoryRow_labelCategory";
};
export type labelCategoryRow_labelCategory$key = {
  readonly " $data"?: labelCategoryRow_labelCategory$data;
  readonly " $fragmentSpreads": FragmentRefs<"labelCategoryRow_labelCategory">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "labelCategoryRow_labelCategory",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowOnTasks",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowOnProjects",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowOnPeople",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "labelRow_labelCategory"
    }
  ],
  "type": "LabelCategory",
  "abstractKey": null
};

(node as any).hash = "9e653a23185d072f7a5e3a6fd25e3002";

export default node;
